module.exports = __webpack_public_path__ + "static/media/icon_data-thresholding.2026b1a4.svg";